/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserNotificationResponse } from './RevisdomAPIViewModelsUserNotificationResponse';
import {
    RevisdomAPIViewModelsUserNotificationResponseFromJSON,
    RevisdomAPIViewModelsUserNotificationResponseFromJSONTyped,
    RevisdomAPIViewModelsUserNotificationResponseToJSON,
    RevisdomAPIViewModelsUserNotificationResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserNotificationResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserNotificationListResponse
 */
export interface RevisdomAPIViewModelsUserNotificationListResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserNotificationResponse>}
     * @memberof RevisdomAPIViewModelsUserNotificationListResponse
     */
    notifications?: Array<RevisdomAPIViewModelsUserNotificationResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserNotificationListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserNotificationListResponse(value: object): value is RevisdomAPIViewModelsUserNotificationListResponse {
    return true;
}

export function RevisdomAPIViewModelsUserNotificationListResponseFromJSON(json: any): RevisdomAPIViewModelsUserNotificationListResponse {
    return RevisdomAPIViewModelsUserNotificationListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserNotificationListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserNotificationListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'notifications': json['notifications'] == null ? undefined : ((json['notifications'] as Array<any>).map(RevisdomAPIViewModelsUserNotificationResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsUserNotificationListResponseToJSON(json: any): RevisdomAPIViewModelsUserNotificationListResponse {
    return RevisdomAPIViewModelsUserNotificationListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserNotificationListResponseToJSONTyped(value?: RevisdomAPIViewModelsUserNotificationListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notifications': value['notifications'] == null ? undefined : ((value['notifications'] as Array<any>).map(RevisdomAPIViewModelsUserNotificationResponseToJSON)),
    };
}

